// utils/reportingPeriod.js
import dayjs from 'dayjs';

export const QUARTERS = {
  Q1: { startMonth: 0, endMonth: 2 },  // Jan–Mar (dayjs months are 0-indexed)
  Q2: { startMonth: 3, endMonth: 5 },  // Apr–Jun
  Q3: { startMonth: 6, endMonth: 8 },  // Jul–Sep
  Q4: { startMonth: 9, endMonth: 11 }, // Oct–Dec
};

export const isLeapYear = (year) =>
  (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0;

export const getDefaultAnnualPeriod = (year = dayjs().year()) => ({
  start: dayjs(`${year}-01-01`),
  end: dayjs(`${year}-12-31`),
});

// dayjs .endOf('month') auto-resolves Feb 28 vs 29 — leap year handled for free
export const getQuarterPeriod = (quarter, year = dayjs().year()) => {
  const q = QUARTERS[quarter];
  if (!q) throw new Error(`Invalid quarter: ${quarter}`);
  const start = dayjs(new Date(year, q.startMonth, 1));
  const end = dayjs(new Date(year, q.endMonth, 1)).endOf('month');
  return { start, end };
};

export const daysInQuarter = (quarter, year = dayjs().year()) => {
  const { start, end } = getQuarterPeriod(quarter, year);
  return end.diff(start, 'day') + 1;
};

/**
 * Validates the reporting period.
 * - Annual: just needs valid start < end (dates are auto-filled anyway).
 * - Non-Annual (Quarterly etc.): enforces a 3-calendar-month minimum span.
 */
export const validateReportingPeriod = (start, end, frequency) => {
  if (!start || !end) return { valid: false, message: 'Start and end dates are required.' };
  if (!dayjs.isDayjs(start)) start = dayjs(start);
  if (!dayjs.isDayjs(end)) end = dayjs(end);

  if (!start.isValid() || !end.isValid()) {
    return { valid: false, message: 'Please enter valid dates.' };
  }
  if (!end.isAfter(start)) {
    return { valid: false, message: 'End date must be after start date.' };
  }
  if (frequency && frequency !== 'Annual') {
    const minEnd = start.add(3, 'month');
    if (end.isBefore(minEnd)) {
      return {
        valid: false,
        message: 'Reporting period must cover a minimum of 3 months when a non-annual frequency is used.',
      };
    }
  }
  return { valid: true };
};